import Rails from '@rails/ujs';
Rails.start();
import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import TurbolinksAdapter from './plugins/vue-turbolinks';

Vue.use(VueAxios, axios);
Vue.use(TurbolinksAdapter);

Vue.config.devtools = true;

const token = document.getElementsByName('csrf-token')[0].getAttribute('content');
axios.defaults.headers.common['X-CSRF-Token'] = token;
axios.defaults.headers.common.Accept = 'application/json';
